/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ leftChain: NonNullable<unknown>, prettyRatio: NonNullable<unknown>, leftMetric: NonNullable<unknown>, rightChain: NonNullable<unknown>, rightMetric: NonNullable<unknown> }} Chain_Page_Compare_Validators_Or_Miners_Different_Left_BetterInputs */



/**
* | output |
* | --- |
* | "{leftChain} has {prettyRatio} more {leftMetric} than {rightChain} has {rightMetric}" |
*
* @param {Chain_Page_Compare_Validators_Or_Miners_Different_Left_BetterInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const chain_page_compare_validators_or_miners_different_left_better = /** @type {((inputs: Chain_Page_Compare_Validators_Or_Miners_Different_Left_BetterInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chain_Page_Compare_Validators_Or_Miners_Different_Left_BetterInputs, { locale?: "en" }, {}>} */ ((i, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ (`${i?.leftChain} has ${i?.prettyRatio} more ${i?.leftMetric} than ${i?.rightChain} has ${i?.rightMetric}`)
});